export default __webpack_public_path__ + "static/media/Group 11858.1399a9b5.svg";